import QuillEditor from "../util/QuillEditor";
import styles from "./PageEdit.module.css"

// component
import TextInput from "./TextInput";
import ImageSelector from "./ImageSelector";

/**
 * A reusable section editor component.
 *
 * @param {bool} setImage - Display thee ability to set an image for the section.
 * @param {string} sectionKey - The section key (e.g., "Sec1", "PageHeader"), used as key in the json data.
 * @param {string} header - The section header text.
 * @param {string} secName - The section name.
 * @param {string} text - The section text.
 * @param {string} imageUrl - The section image URL.
 * @param {Function} updateField - Function to update the parent state.
 * @param {string} who - contact person.
 * @param {string} where - the location of the event.
 * @param {string} when - at what time and date/day the event is.
 * @param {string} mobile - the phone number of the contact person.
 * @param {string} mobile - the email address of the contact person.
 * 
 * As shown in the example only sectionKey, header and updateField is needed
 * the rest is provided by the PageEdit component.
 *
 * @example
 * <PageInfoEdit setImage={True} sectionKey="Sec1" header={data.Sec1.header} updateField={updateField} />
 */

export default function PageInfoWContactInfoEdit({setImage, sectionKey, header, text, imageUrl, id, secName, updateField, who, where, when, mobile, email}) {

    return(
        <div className={styles.pageInfoEdit}>
             <h2>{header}</h2>

            {/* Header Input */}
            <TextInput
                label={"Header:"}
                value={header}
                onChange={(e) => updateField(sectionKey, "header", e.target.value)}
            />

            {/* Content id */}
            <TextInput
                label={"Id:"}
                value={id}
                onChange={(e) => updateField(sectionKey, "secId", e.target.value)}
            />

            {/* content section Name */}
            <TextInput
                label={"Sektion navn:"}
                value={secName}
                onChange={(e) => updateField(sectionKey, "secName", e.target.value)}
            />

            {/* Content Editor */}

            <QuillEditor
                value={text || ""}
                onChange={(value) => updateField(sectionKey, "text", value)}
                placeholder="Write your content here..."
            />

            {/* Image Upload */}
            {setImage ?( <ImageSelector 
                value={imageUrl || ""}
                updateField={(val) => updateField(sectionKey, "imageUrl", val)}
            />): null}

            {/* contact info */}
            <h3>Kontakt Info</h3>
            <div className={styles.infoBox}>
                <TextInput
                label={"Hvornår:"}
                value={when}
                onChange={(e) => updateField(sectionKey, "when", e.target.value)}
            />

            <TextInput
                label={"Hvor:"}
                value={where}
                onChange={(e) => updateField(sectionKey, "where", e.target.value)}
            />

            <TextInput
                label={"Hvem skal man kontakte:"}
                value={who}
                onChange={(e) => updateField(sectionKey, "who", e.target.value)}
            />

            <TextInput
                label={"mobil:"}
                value={mobile}
                onChange={(e) => updateField(sectionKey, "mobile", e.target.value)}
            />

            <TextInput
                label={"Email:"}
                value={email}
                onChange={(e) => updateField(sectionKey, "email", e.target.value)}
            />
            </div>
        </div>
    );

}